function getUserDisplayName(user, configuredName) {
  var value = user || {}
  var firstName = firstNonEmpty(value.firstName, value.firstname)
  var lastName = firstNonEmpty(value.lastName, value.lastname)
  var name = [firstName, lastName].filter(Boolean).join(' ')

  return name || firstNonEmpty(value.displayName, value.fullName, value.name, value.label, configuredName) || 'Utilisateur'
}

function firstNonEmpty() {
  for (var index = 0; index < arguments.length; index += 1) {
    var value = String(arguments[index] || '').trim()
    if (value) return value
  }
  return ''
}

export { getUserDisplayName }
